<template>
  <v-dialog scrollable max-width="800px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn small text v-on="on" @click="getGrupoMacheo">
          <v-icon left>edith</v-icon>
          Admin
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>Macheos Admin</h4>
      </v-card-title>
      <v-card-text>
        <!-- <AgregarMacheo @uploaded="fileUploaded" /> -->
        <!-- <AgregarMacheo @nuevoGrupoMacheo="getGrupoMacheo" /> -->
        <AgregarMacheoClipboard @nuevoGrupoMacheo="getGrupoMacheo" />
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nombre</th>
                <th class="text-left">Descripcion</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="grupo in grupos" :key="grupo.id">
                <td>{{ grupo.nombre }}</td>
                <td>{{ grupo.descripcion }}</td>
                <td>
                  <EstadoMacheo :grupoMacheoId="grupo.id"/>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";
// import AgregarMacheo from "@/components/macheo/AgregarMacheo";
import AgregarMacheoClipboard from "@/components/macheo/AgregarMacheoClipboard";
import EstadoMacheo from "@/components/macheo/EstadoMacheo";


export default Vue.extend({
  props: ["id", "cedula"],
  data() {
    return {
      loading: false,
      showDialog: false,
      grupos: [],
    };
  },
  mounted() {},

  methods: {
    volver() {
      this.showDialog = false;
    },
    fileUploaded(uploadData) {
      console.log("**********************", uploadData);
    },
    getGrupoMacheo() {
      console.log("get grupo macheo");
      axios
        .get("/macheo/getGrupoMacheo")

        .then((res) => {
          this.grupos = res.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
  components: {
    // AgregarMacheo,
    AgregarMacheoClipboard,
    EstadoMacheo
  },
});
</script>
